const GoalLinePlugin = {
  id: "goalLine",
  beforeDatasetsDraw: (chart, args, options) => {
    const annualGoal = options.annualGoal ?? options.goal;
    const {monthlyGoal} = options;

    if (!annualGoal && !monthlyGoal) return true;

    const {
      ctx,
      scales: { x, y },
    } = chart;

    if (monthlyGoal) {
      const monthlyYPixel = y.getPixelForValue(monthlyGoal);

      ctx.save();
      ctx.beginPath();
      ctx.strokeStyle = "#999999";
      ctx.setLineDash([]);
      ctx.moveTo(x.left, monthlyYPixel);
      ctx.lineTo(x.left + x.width, monthlyYPixel);
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }

    if (annualGoal) {
      const annualYPixel = y.getPixelForValue(annualGoal);

      ctx.save();
      ctx.beginPath();
      ctx.strokeStyle = "#999999";
      ctx.setLineDash([8, 4]);
      ctx.moveTo(x.left, annualYPixel);
      ctx.lineTo(x.left + x.width, annualYPixel);
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }

    return true;
  },
};

export default GoalLinePlugin;
